export const navHeight = 64;
export const sidebarExpanded = 220; // icon + full label
export const sidebarCollapsed = 80; // icon over label
export const navBg = '#1d1e2e';

export const shellGutter = { xs: 2, sm: 3 };
export const contentGutter = { xs: 2, md: 3 };

export const containerSx = {
  width: '100%',
  mx: 'auto',
  px: shellGutter,
  '@media (min-width:576px)': { maxWidth: 540 },
  '@media (min-width:768px)': { maxWidth: 720 },
  '@media (min-width:992px)': { maxWidth: 960 },
  '@media (min-width:1200px)': { maxWidth: 1140 },
  '@media (min-width:1400px)': { maxWidth: 1366 },
};

export const fluidContainerSx = {
  width: '100%',
  px: shellGutter,
};
